export const redirectTo404 = (): void => {
  window.location.href = '/404';
};
